import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'RemoveVoohMediaTemplatePayload'

export const REMOVE_VOOH_MEDIA_TEMPLATE = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation removeVoohMediaTemplate($id: ID!) {
    removeVoohMediaTemplate(input: { id: $id }) {
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
